<template>
    <div>
        <a-drawer :title="title" width="1100" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
            <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
                <a-row :gutter="10">
                    <a-col :span="6">
                        <a-form-model-item label="昵称" prop="name">
                            <a-input v-model="field.name" placeholder="请填写昵称" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="绑定码" prop="code" v-if="!field.id">
                            <a-input v-model="field.code" placeholder="请填写微信绑定码" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="绑定码有效期（小时）" prop="hour" v-if="!field.id">
                            <a-input-number v-model="field.hour" :min="1" :max="360" suffix="小时" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-form-model-item label="标签" prop="tags">
                    <a-input v-model="field.tags" placeholder="请填写标签内容，多个以小写英文逗号区分" />
                </a-form-model-item>
                <a-row :gutter="10">
                    <a-col :span="6">
                        <a-form-model-item label="会员级别" prop="level">
                            <a-select v-model="field.level" placeholder="请选择会员级别">
                                <template v-for="(val, key) in $enums.UserLevel">
                                    <a-select-option :value="key" :key="key">
                                        {{ val }}
                                    </a-select-option>
                                </template>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="会员到期时间" prop="lvexp">
                            <a-date-picker v-model="field.lvexp" :disabled="field.level === 'Normal' || field.level === 'Member'" placeholder="请选择到期时间" value-format="YYYY-MM-DD" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="真实姓名（实名认证）" prop="cname" v-if="field.level != 'Normal'">
                            <a-input v-model="field.cname" placeholder="请填写真实姓名" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="身份证号（实名认证）" prop="csno" v-if="field.level != 'Normal'">
                            <a-input v-model="field.csno" placeholder="请填写身份证号" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="10">
                    <a-col :span="6">
                        <a-form-model-item label="手机号" prop="mob">
                            <a-input v-model="field.mob" placeholder="请填写手机号" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="18">
                        <a-form-model-item label="地址" prop="addr">
                            <a-input-search v-model="field.addr" placeholder="请选择所在位置" enter-button="选择位置" @search="() => (map = true)" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="10">
                    <a-col :span="6">
                        <a-form-model-item label="微信号" prop="wxkey">
                            <a-input v-model="field.wxkey" placeholder="请填写微信号" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="QQ" prop="qq">
                            <a-input v-model="field.qq" placeholder="请填写QQ号" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="邮箱" prop="email">
                            <a-input v-model="field.email" placeholder="请填写邮箱地址" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="心理师级别" prop="clv">
                            <a-select v-model="field.clv" placeholder="请选择心理师级别">
                                <template v-for="(val, key) in $enums.CtaLevel">
                                    <a-select-option :value="key" :key="key">
                                        {{ val }}
                                    </a-select-option>
                                </template>
                            </a-select>
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-form-model-item label="头像" prop="logo">
                    <ImageUpload type="Avatar" v-if="show" :img.sync="field.avatar"></ImageUpload>
                </a-form-model-item>
                <a-row :gutter="10">
                    <a-col :span="6">
                        <a-form-model-item label="性别" prop="gender">
                            <a-radio-group v-model="field.gender" button-style="solid">
                                <template v-for="(val, key) in $enums.Gender">
                                    <a-radio-button :value="key" :key="key">
                                        {{ val }}
                                    </a-radio-button>
                                </template>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="出生日期" prop="birth">
                            <a-date-picker v-model="field.birth" placeholder="请选择出生日期" value-format="YYYY-MM-DD" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="婚姻状况" prop="marry">
                            <a-radio-group v-model="field.marry" button-style="solid">
                                <a-radio-button value="未婚">
                                    未婚
                                </a-radio-button>
                                <a-radio-button value="已婚">
                                    已婚
                                </a-radio-button>
                                <a-radio-button value="离异">
                                    离异
                                </a-radio-button>
                                <a-radio-button value="丧偶">
                                    丧偶
                                </a-radio-button>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="政治面貌" prop="polit">
                            <a-input v-model="field.polit" placeholder="请填写政治面貌" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="10">
                    <a-col :span="6">
                        <a-form-model-item label="工作单位" prop="wunit">
                            <a-input v-model="field.wunit" placeholder="请填写工作单位" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="工作部门" prop="wdept">
                            <a-input v-model="field.wdept" placeholder="请填写工作部门" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="从业年份" prop="wyear">
                            <a-input v-model="field.wyear" placeholder="请填写从业年份" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="教授课程" prop="course">
                            <a-input v-model="field.course" placeholder="请填写教授课程" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="10">
                    <a-col :span="6">
                        <a-form-model-item label="是否督导" prop="superv">
                            <a-radio-group v-model="field.superv" button-style="solid">
                                <a-radio-button :value="true">
                                    是
                                </a-radio-button>
                                <a-radio-button :value="false">
                                    否
                                </a-radio-button>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="导师性质" prop="nature">
                            <a-radio-group v-model="field.nature" button-style="solid">
                                <a-radio-button value="学术">
                                    学术
                                </a-radio-button>
                                <a-radio-button value="技能">
                                    技能
                                </a-radio-button>
                            </a-radio-group>
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="职称" prop="rank">
                            <a-input v-model="field.rank" placeholder="请填写职称" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="职务" prop="duty">
                            <a-input v-model="field.duty" placeholder="请填写职务" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row :gutter="10">
                    <a-col :span="6">
                        <a-form-model-item label="面咨费用" prop="fee">
                            <a-input v-model="field.fee" placeholder="请填写面咨费用" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="籍贯" prop="place">
                            <a-input v-model="field.place" placeholder="请填写籍贯" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="毕业院校" prop="school">
                            <a-input v-model="field.school" placeholder="请填写毕业院校" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="6">
                        <a-form-model-item label="所学专业" prop="major">
                            <a-input v-model="field.major" placeholder="请填写所学专业" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-row :gutter="10">
                    <a-col :span="12">
                        <a-form-model-item label="研究方向" prop="resea">
                            <a-textarea v-model="field.resea" placeholder="请填写研究方向" :auto-size="{ minRows: 3, maxRows: 3 }" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="社会任职" prop="jobs">
                            <a-textarea v-model="field.jobs" placeholder="请填写社会任职" :auto-size="{ minRows: 3, maxRows: 3 }" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="10">
                    <a-col :span="12">
                        <a-form-model-item label="知识产权" prop="ipr">
                            <a-textarea v-model="field.ipr" placeholder="请填写个人知识产权" :auto-size="{ minRows: 3, maxRows: 3 }" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="科研著作" prop="works">
                            <a-textarea v-model="field.works" placeholder="请填写个人科研著作" :auto-size="{ minRows: 3, maxRows: 3 }" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-row :gutter="10">
                    <a-col :span="12">
                        <a-form-model-item label="影响力" prop="influ">
                            <a-textarea v-model="field.influ" placeholder="请填写机构影响力" :auto-size="{ minRows: 3, maxRows: 3 }" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="12">
                        <a-form-model-item label="专业实力" prop="stren">
                            <a-textarea v-model="field.stren" placeholder="请填写专业实力" :auto-size="{ minRows: 3, maxRows: 3 }" />
                        </a-form-model-item>
                    </a-col>
                </a-row>
                <a-form-model-item label="个人简介" prop="intro">
                    <a-textarea v-model="field.intro" placeholder="请填写个人简介" :auto-size="{ minRows: 3, maxRows: 3 }" />
                </a-form-model-item>
                <a-row :gutter="10">
                    <a-col :span="6">
                        <a-form-model-item label="数据来源" prop="dsrc">
                            <a-input v-model="field.dsrc" placeholder="请填写数据来源" />
                        </a-form-model-item>
                    </a-col>
                    <a-col :span="18">
                        <a-form-model-item label="来源网址" prop="durl">
                            <a-input v-model="field.durl" placeholder="请填写数据来源网址" />
                        </a-form-model-item>
                    </a-col>
                </a-row>

                <a-form-model-item>
                    <a-button type="primary" @click="doSave" icon="save">
                        保存
                    </a-button>
                    <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                        重置
                    </a-button>
                </a-form-model-item>
            </a-form-model>
        </a-drawer>

        <MapSelector title="选择地点" :show.sync="map" :locs="locs" v-if="map" @change="setLocs"></MapSelector>
    </div>
</template>

<script>
import MapSelector from '@/comp/MapSelector'
import ImageUpload from '@/comp/ImageUpload'

export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    components: {
        MapSelector,
        ImageUpload
    },
    data() {
        return {
            detail: {},
            map: false,
            locs: {},
            field: {
                id: '',
                code: '',
                hour: 360,
                name: '',
                tags: '',
                cname: '',
                csno: '',
                level: 'Normal',
                lvexp: '',
                avatar: '',
                mob: '',
                email: '',
                wxkey: '',
                qq: '',
                addr: '',
                area: '',
                superv: false,
                clv: 'L01',
                gender: 'Secret',
                birth: '',
                wunit: '',
                wdept: '',
                wyear: '',
                nature: '学术',
                slevel: '',
                fee: '',
                marry: '未婚',
                intro: '',
                polit: '',
                resea: '',
                course: '',
                rank: '',
                duty: '',
                jobs: '',
                edu: '',
                degree: '',
                ipr: '',
                works: '',
                dsrc: '',
                durl: '',
                influ: '',
                stren: '',
                locs: '',
                place: '',
                school: '',
                major: ''
            },
            rules: {
                name: [{ required: true, message: '请填写昵称', trigger: 'blur' }],
                mob: [{ required: true, message: '请填写手机号', trigger: 'blur' }],
                addr: [{ required: true, message: '请选择所在地区', trigger: 'blur' }],
                level: [{ required: true, message: '请选择会员等级', trigger: 'change' }],
                clv: [{ required: true, message: '请选择心理师等级', trigger: 'change' }],
                superv: [{ required: true, message: '请选择是否导师', trigger: 'change' }]
            }
        }
    },
    mounted() {
        if (this.item.id) {
            this.$http
                .get('/ums/plat/cta/detail', {
                    params: {
                        id: this.item.id
                    }
                })
                .then(result => {
                    this.detail = result.data
                    Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))

                    this.field.cname = this.detail.cert.name || ''
                    this.field.csno = this.detail.cert.sno || ''

                    this.locs.locs = this.detail.locs || ''
                    this.locs.code = this.detail.area
                    this.locs.addr = this.detail.addr
                })
        }
    },
    methods: {
        setLocs(locs) {
            this.field.locs = locs.locs
            this.field.area = locs.code
            this.field.addr = locs.addr
            this.locs = locs
        },
        doSave() {
            if (!this.field.id) {
                if (!this.field.code) {
                    this.$message.error('请填写绑定码')
                    return
                }
                if (!this.field.hour) {
                    this.$message.error('请填写绑定码有效期')
                    return
                }
            }
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.$http.post('/ums/plat/cta/save', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('保存成功')
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            if (this.item.id) {
                Object.keys(this.field).forEach(key => (this.field[key] = this.detail[key] != undefined ? this.detail[key] : this.field[key] || ''))
            }
        }
    }
}
</script>
